import { render } from "./HelpCard.vue?vue&type=template&id=4ef267ea&scoped=true&bindings={}"
import script from "./HelpCard.vue?vue&type=script&lang=ts"
export * from "./HelpCard.vue?vue&type=script&lang=ts"

import "./HelpCard.vue?vue&type=style&index=0&id=4ef267ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4ef267ea"

export default script